<template>
    <div class="mt-8">
        <ModalGlobal
            id="video360"
            class=""
            v-if="video360"
            @close-modal="video360 = false"
        >
            <template #dialogHeadImg>
                <img
                    class="absolute h-22 -top-12 left-0 right-0 m-auto pointer-events-none"
                    :src="$S3AssetUrl('suf/home/photo-pass-logo.png')"
                    alt="logo photo"
                />
            </template>

            <!-- <template #dialogHeading>¿Esta seguro quieres cerrar sesión?</template> -->

            <template #dialogDescription>
                <video
                    autoplay
                    controls
                    preload="auto"
                    class="w-full"
                    :poster="$S3AssetUrl('suf/videos/watch360.jpg')"
                >
                    <source
                        :src="$S3AssetUrl('movies/Video_360_2022.mp4')"
                        type="video/mp4;"
                    />
                </video>
            </template>

            <button
                @click="video360 = false"
                type="button"
                class="w-full flex justify-center rounded-full py-3 px-4 mb-1 border-yellow-photo border bg-yellow-photo cursor-pointer font-semibold mx-auto"
            >
                {{ $t("gallery.vd.close") }}
            </button>
        </ModalGlobal>

        <ModalGlobal
            id="modalSelectVideo"
            class="modalDialog"
            v-if="modalSelectVideo"
            @close-modal="modalSelectVideo = false"
        >
            <template #dialogHeadImg>
                <img
                    class="absolute h-22 -top-12 left-0 right-0 m-auto pointer-events-none"
                    :src="$S3AssetUrl('suf/home/photo-pass-logo.png')"
                    alt="logo photo"
                />
            </template>

            <template #dialogHeading>{{
                $t("gallery.vd.choose_yours")
            }}</template>

            <template #dialogDescription>
                {{ $t("gallery.vd.qn_choose") }}
                <br /><br />
                {{ $t("gallery.vd.info_choose") }}
                <strong>{{ $t("gallery.vd.confirm") }}</strong>
                {{ $t("gallery.vd.warn_choose") }}
            </template>

            <div class="flex my-4">
                <button
                    type="button"
                    class="flex w-24 justify-center flex-auto rounded-full py-3 px-4 border-yellow-photo border bg-yellow-photo cursor-pointer font-semibold"
                    @click="
                        UnlockVideo({
                            MediaId: videoSelected.MediaId || videoSelected.VideoId,
                            AlbumKey: album.AlbumKey,
                        })
                    "
                >
                    {{ $t("gallery.vd.confirm") }}
                </button>

                <button
                    @click="modalSelectVideo = false"
                    type="button"
                    class="flex w-24 justify-center flex-auto justify-center rounded-full py-3 px-4 border-yellow-photo border bg-white cursor-pointer font-semibold ml-4"
                >
                    {{ $t("gallery.vd.deny") }}
                </button>
            </div>
        </ModalGlobal>

        <Banner
            v-if="!albumNotFound && !albumLoadError && (freeGallery || Object.keys(album).length)"
            :visitDate="album?.ExpiresDate || null"
            :unlocked="album?.Unlocked || false"
            :parkId="parkId"
        ></Banner>

        <div
            v-if="albumLoadError"
            class="container mx-auto flex flex-col items-center justify-center py-12 text-center"
        >
            <img
                class="no-data"
                :src="$S3AssetUrl('suf/no-data.png')"
                alt=""
            />
            <p class="mt-4 font-semibold">
                {{ $t("messages.service_temporarily_unavailable") }}
            </p>
        </div>

        <div
            v-else-if="albumNotFound"
            class="container mx-auto flex justify-center py-12"
        >
            <img
                class="no-data"
                :src="$S3AssetUrl('suf/no-data.png')"
                alt=""
            />
        </div>
        
        <div class="flex flex-col-reverse md:flex-row container mx-auto" v-if="album?.AlbumMode === AlbumModeEnum.INDIVIDUAL_SALE && albumes?.Type === AlbumSearchTypeEnum.DOWNLOADCODE">
            <div v-if="album?.DetailsServiceMedia?.Selected == 0" class="alert alert-warning alert-dismissible bg-blue-700 text-white px-3 py-3 border-b-4 rounded w-full" role="alert">
                {{ $t("gallery.sale_mode_description_single", { limit: album?.DetailsServiceMedia?.Limit }) }}
            </div>
            <div v-else-if="album?.DetailsServiceMedia?.Available > 0" class="alert alert-warning alert-dismissible bg-blue-700 text-white px-3 py-3 border-b-4 rounded w-full" role="alert">
                {{ $t("gallery.sale_mode_description", { limit: album?.DetailsServiceMedia?.Limit, selected: album?.DetailsServiceMedia?.Selected, available: album?.DetailsServiceMedia?.Available }) }}
            </div>
            <div v-else-if="album?.DetailsServiceMedia?.Limit == 0 && album?.DetailsServiceMedia?.Available == 0" class="alert alert-warning alert-dismissible bg-blue-700 text-white px-3 py-3 border-b-4 rounded w-full" role="alert">
                {{ $t("gallery.sale_mode_description_limit_stop", { limit: album?.DetailsServiceMedia?.Limit }) }}
            </div>
        </div>

        <section
            v-if="!albumNotFound && !albumLoadError"
            id="gallery"
            class="flex flex-col-reverse md:flex-row container mx-auto"
        >
            <!-- Video -->
            <div
                class="active tabs-content w-full md:w-8/11 border-t border-yellow-photo md:border-t-0 mt-4 md:mt-0"
                v-if="albumType == 1"
            >
                <div class="controlGallery flex py-3 px-2 justify-center">
                    <div class="md:flex flex-1 items-center">
                        <router-link
                            class="backTo cursor-pointer bg-lightgreen-photo text-white rounded pl-4 pr-4"
                            :to="{
                                name: 'albumes',
                            }"
                        >
                            <span class="pointer-events-none">
                                {{ $t("messages.my_albumes") }}
                            </span>
                        </router-link>
                        <span class="material-icons mx-4"> chevron_right </span>
                        <span>
                            <span
                                class="pointer-events-none underline"
                                v-if="album.Park"
                            >
                                {{ album.Park.Name }}
                            </span>
                        </span>
                    </div>
                    <span>{{ $t("gallery.videos") }}</span>
                </div>

                <div class="skeleton-hi106u5oqy3" v-if="$store.state.loading">
                    <a class="card" id="card-link" target="_blank">
                        <div class="hidden card__header">
                            <div>
                                <img
                                    class="card__header header__img skeleton"
                                    id="logo-img"
                                    alt=""
                                />
                            </div>
                            <h3
                                class="card__header header__title"
                                id="card-title"
                            >
                                <div class="skeleton skeleton-text">&nbsp;</div>
                                <div class="skeleton skeleton-text">&nbsp;</div>
                            </h3>
                        </div>

                        <div class="card__body">
                            <div class="relative card__body body__img">
                                <img
                                    class="skeleton card__video"
                                    alt=""
                                    id="cover-img"
                                />
                                <div
                                    class="absolute bottom-0 left-0 right-0 text-center top-0"
                                >
                                    <span
                                        class="material-icons skeleton text-link-blue"
                                    >
                                        play_arrow
                                    </span>
                                </div>
                            </div>

                            <div class="skeleton skeleton-text">&nbsp;</div>
                            <div class="skeleton skeleton-text">&nbsp;</div>
                        </div>

                        <div class="hidden card__footer" id="card-footer">
                            <div
                                class="skeleton skeleton-text skeleton-footer"
                            ></div>
                        </div>
                    </a>
                </div>
                <div
                    class="flex flex-wrap border-yellow-photo border-b pb-4 mb-4"
                    v-else-if="videos.length"
                >
                    <div class="video-container w-full relative">
                        <video
                            :key="videoIdx"
                            class="w-full mb-4"
                            preload="auto"
                            :poster="videoSelected.Thmb"
                            controls
                            :controlslist="controlValidationDownload"
                        >
                            <template v-if="isVideoBlocked">
                                <source
                                    :src="videoSelected.Orig"
                                    type="video/mp4"
                                />
                            </template>

                            <source
                                label="720p"
                                :src="videoSelected.Prev"
                                type="video/mp4"
                                v-else
                            />
                        </video>
                    </div>

                    <div class="flex w-full">
                        <div class="flex flex-col font-semibold px-2 flex-auto">
                            <span>Video: {{ videoSelected.VideoName }}</span>
                            <span>Tag: {{ FormatMediaTags(videoSelected.Tags) }}</span>
                            <!-- <span>Id: {{ videoSelected.VideoId }}</span> -->
                        </div>

                        <template v-if="isFreeVideo">
                            <button
                                class="bg-lightgreen-photo text-white focus:outline-none font-bold px-8 py-1 uppercase cursor-no-drop"
                                type="button"
                            >
                                {{ $t("gallery.free_video_in_photo_pack") }}
                                <span class="material-icons">
                                    card_giftcard
                                </span>
                            </button>
                        </template>
                        <button
                            class="uppercase bg-yellow-photo px-8 py-1 focus:outline-none font-bold"
                            @click="modalSelectVideo = true"
                            type="button"
                            v-else-if="isSelectVideos"
                        >
                            {{ $t("gallery.vd.choose") }}
                            <span class="material-icons"> star </span>
                        </button>
                        <template v-else>                           
                            <button
                                @click.prevent="
                                    AddVideoToShoppingCart(
                                        videoSelected,
                                        albumes.uuid,
                                        videosRelated,
                                        album
                                    )
                                "
                                class="uppercase bg-lightgreen-photo text-white px-8 py-1 focus:outline-none font-bold"
                                type="button"
                                v-if="!videoSelected.Unlocked &&
                                    albumes.order !== 1 &&
                                    albumes.order !== 3 &&
                                    albumes.order == undefined"
                            >
                                {{ $t("gallery.cart_add") }}
                                <span class="material-icons">
                                    local_grocery_store
                                </span>
                            </button>
                        </template>
                    </div>
                </div>
                <template v-else>
                    <div
                        class="galleryEmpty flex flex-wrap -mb-1 justify-center py-8"
                    >
                        <img
                            class="no-data"
                            :src="$S3AssetUrl('suf/no-data.png')"
                            alt=""
                        />
                        <p class="no-data-text">
                            {{ $t("Validations.no_data_fund") }}
                        </p>
                    </div>
                </template>

                <div class="flex flex-wrap -mb-1 hidden" v-if="videos.length">
                    <template v-for="(item, idx) in videos">
                        <div
                            class="checkPhoto selected w-1/5 mb-6 px-2 relative cursor-pointer"
                            :key="idx"
                        >
                            <!-- {{item}} -->
                            <div class="select absolute z-10">
                                <span
                                    class="material-icons"
                                    v-if="item.isAdded"
                                >
                                    check_circle
                                </span>
                                <span class="material-icons" v-else>
                                    radio_button_unchecked
                                </span>
                            </div>
                            <img
                                @click="videosSelected(item)"
                                :alt="item.VideoName"
                                :class="item.isAdded && 'selected'"
                                class="w-full cursor-pointer"
                                :src="$S3AssetUrl('suf/videos/thumbnail.jpg')"
                            />
                        </div>
                    </template>
                </div>

                <div
                    class="galleryEmpty flex flex-wrap -mb-1 justify-center py-8"
                    v-else
                ></div>
            </div>

            <!-- Galleria -->
            <div
                class="active tabs-content w-full md:w-8/11 border-t border-yellow-photo md:border-t-0 mt-4 md:mt-0"
                v-if="albumType == 0"
            >
                <template v-if="gallery">
                    <div class="controlGallery flex py-3 px-2 justify-center">
                        <div class="md:flex flex-1 items-center">
                            <router-link
                                class="backTo cursor-pointer bg-lightgreen-photo text-white rounded pl-4 pr-4"
                                :to="{
                                    name: 'albumes',
                                }"
                            >
                                <span class="pointer-events-none">
                                    <span class="material-icons">
                                        arrow_back
                                    </span>
                                    {{ $t("messages.my_albumes") }}
                                </span>
                            </router-link>
                            <span class="material-icons mx-4">
                                chevron_right
                            </span>
                            <span>
                                <span
                                    class="pointer-events-none underline"
                                    v-if="album.Park"
                                >
                                    {{ album.Park.Name }}
                                </span>
                            </span>
                        </div>
                        <template v-if="!isMobileDevice">
                            <span class="flex"
                            v-if="
                                album.Unlocked && galleryOnlyAvailable.length > 0
                            "
                        >
                         <span :class="{'selection-counter' : true, 'on-visible': mediaSelected.length}">
                                {{
                                    $tc(
                                        "gallery.selected_photos",
                                        mediaSelected.length
                                    )
                                }}
                            </span>
                            <a
                                @click="unSelectAllMultimedia()"
                                class="backTo cursor-pointer bg-yellow-photo border-yellow-photo rounded pl-4 pr-4 cursor-pointer mr-2"
                                v-if="mediaSelected.length"
                            >
                                <span class="pointer-events-none">
                                    <span class="material-icons">deselect</span> {{ $t("gallery.deselect") }}
                                </span>
                            </a>
                            <a
                                @click="selectAllMultimedia()"
                                class="backTo cursor-pointer border-newxcaret-gray justify-end rounded pl-4 pr-4 cursor-pointer mr-2"
                                v-else
                            >
                                <span class="pointer-events-none">
                                    <span class="material-icons">check_circle</span> {{ $t("gallery.select") }}
                                </span>
                            </a>
                        </span>
                        </template>
                    </div>

                    <div :key="galleryIdx">
                        <LightGallery
                            :images="lightGallery"
                            :index="index"
                            :disable-scroll="true"
                            @close="index = null;"
                            @slide="onSlide"
                        />

                        <div
                            class="gallery flex flex-wrap -mb-1"
                            v-if="gallery.length"
                        >
                            <GalleryItem
                                    v-for="(item, idx) in gallery"
                                    :key="idx"
                                    :item="item"
                                    :index="idx"
                                    :album="album"
                                    :albumes="albumes"
                                    :mediaPurchasedList="galleryOnlyAvailable"
                                    :mediaMaxSelection="mediaMaxSelection"
                                    :isIndividualMediaSale="isIndividualMediaSale"
                                    :freeGallery="freeGallery"
                                    @selectedMediaForDownload="selectedMediaForDownload"
                                    @userUnlockSelection="userUnlockSelection"
                                    @preview="index = $event"
                            />
                        </div>
                    </div>
                </template>

                <div
                    class="galleryEmpty flex flex-wrap -mb-1 justify-center py-8"
                    v-else
                >
                    <img
                        class="no-data"
                        :src="$S3AssetUrl('suf/no-data.png')"
                        alt=""
                    />
                    <p class="no-data-text">
                        {{ $t("Validations.no_data_fund") }}
                    </p>
                    <p>
                        <router-link
                            class="text-base bg-lightgreen-photo text-white rounded p-2 pl-4 pr-4 cursor-pointer"
                            :to="{
                                name: 'albumes',
                            }"
                        >
                            <span class="pointer-events-none">
                                <span class="material-icons"> arrow_back </span>
                                {{ $t("messages.my_albumes") }}
                            </span>
                        </router-link>
                    </p>
                </div>

                <PaginacionGallery
                    :pages="pagination"
                    :currentPage="$route.query.page"
                    @page-changed="loadPaginate"
                />
            </div>

            <div
                class="flex flex-col w-full md:w-3/11 mx-auto px-4 pt-8 tabsMenu"
            >
                <div class="w-full flex justify-right items-end pb-4">
                    <template>
                        <button
                            @click="changeTab(0)"
                            class="w-1/2 rounded-t-lg py-2 px-4 border-black bg-white"
                            :class="
                                albumType == 0
                                    ? 'active border-x border-t'
                                    : ' border-b'
                            "
                            type="button"
                            v-if="hasPhotos"
                        >
                            <span class="material-icons"> perm_media </span>
                            <span class="font-semibold">{{
                                $t("gallery.fotos")
                            }}</span>
                        </button>
                        <button
                            @click="changeTab(1)"
                            class="w-1/2 rounded-t-lg py-2 px-4 border-black bg-white"
                            :class="
                                albumType == 1
                                    ? 'active border-x border-t'
                                    : ' border-b'
                            "
                            type="button"
                            v-if="hasVideo"
                        >
                            <span class="material-icons"> smart_display </span>
                            <span class="font-semibold">{{
                                $t("gallery.videos")
                            }}</span>
                        </button>
                    </template>
                </div>

                <div class="active tabs-content" v-if="albumType == AlbumTypeEnum.PHOTO">
                    <template v-if="lockedMediaList.length && album?.AlbumMode === AlbumModeEnum.INDIVIDUAL_SALE">
                        <div class="font-bold p-2">
                            {{ $t("gallery.unlock_selected_media") }}:
                        </div>
                        <a
                            @click.stop="unlockUserSelectedMedia()"
                            v-if="album.AlbumType == 0 && gallery.length"
                            class="unclockmediabutton flex justify-center rounded-full py-2 px-4 my-2 bg-blue-700 text-white border border-grey font-semibold hover:scale-105 duration-300 cursor-pointer"
                        >
                            {{ $t("gallery.unlock_progress", { current: lockedMediaList.length, total: mediaMaxSelection }) }}
                        </a>
                    </template>

                    <template
                        v-if="album.Unlocked && galleryOnlyAvailable.length"
                    >
                        <div class="font-bold p-2" v-if="mediaSelected.length">
                            {{ $t("gallery.download_photos") }}
                        </div>
                        <template v-if="mediaSelected.length">
                            <a
                                @click.stop="directDownload()"
                                class="flex justify-center rounded-full py-2 px-4 my-2 bg-yellow-photo border font-semibold"
                                :class="
                                    $store.state.downloaded.progressing
                                        ? 'disabled'
                                        : 'hover:scale-105 duration-300 cursor-pointer'
                                "
                                v-if="mediaSelected.length"
                            >
                                {{
                                    $tc(
                                        `gallery.download_selected`,
                                        mediaSelected.length
                                    )
                                }}
                            </a>
                            <a
                                @click.stop="downloadSelectedPhotosAsZip()"
                                class="zipBottonDownload hidden-less-ipad flex justify-center rounded-full py-2 px-4 my-2 border border-grey font-semibold"
                                :class="
                                    $store.state.downloaded.progressing
                                        ? 'disabled'
                                        : 'hover:scale-105 duration-300 cursor-pointer'
                                "
                                v-if="mediaSelected.length >= 15"
                            >
                                {{
                                    $tc(
                                        `gallery.download_selected_as_zip`,
                                        mediaSelected.length
                                    )
                                }}
                            </a>
                        </template>
                        <a
                            v-if="album.AlbumType == 0 && gallery.length"
                            @click.once="compressZipPhotos()"
                            class="zipBottonDownload flex justify-center rounded-full py-2 px-4 my-2 bg-white border border-grey font-semibold hover:scale-105 duration-300 cursor-pointer"
                        >
                            {{ $tc("gallery.zip_button", album?.AlbumMode === AlbumModeEnum?.INDIVIDUAL_SALE ? galleryOnlyAvailable.length : album?.TotalMedia) }}
                        </a>
                    </template>

                    <div class="font-bold p-2" v-if="!freeGallery">
                        {{ $t("gallery.view_photos") }}
                    </div>

                    <template v-if="albumes.Type == 2">
                        <span class="font-bold mr-1">
                            {{ $t("gallery.room") }}
                        </span>
                        {{ albumes.code }}
                    </template>
                    <div class="shoppingCart">
                        <div class="flex px-4 text-sm mt-2">
                            <template v-if="albumes.Type == 1">
                                <span class="font-bold mr-1">
                                    {{ $t("gallery.tag") }}
                                </span>
                                {{ albumes.code }}
                            </template>
                            <template v-if="albumes.Type == 0">
                                <span class="font-bold mr-1">
                                    {{ $t("gallery.code") }}
                                </span>
                                {{ albumes.code }}
                            </template>
                        </div>
                        <div class="parkList">
                            <div
                                class="item"
                                v-for="(item, idx) in albumes.park"
                                :key="idx"
                            >
                                <template v-if="item.AlbumType == AlbumTypeEnum.PHOTO">
                                    <a
                                        class="flex flex-col cursor-pointer hover:scale-105 duration-300"
                                        :href="absoluteRoute(item, albumes)"
                                    >
                                        <div
                                            class="flex mx-2 px-2 py-3 relative"
                                        >
                                            <img
                                                :src="$S3AssetUrl('/suf/logos/min/hotel-' + item.Park.Id + '.png')"
                                                class="imgCut hidden-just-tb w-1/5"
                                                v-if="item.Park.IsHotel"
                                            />
                                            <img
                                                :src="$S3AssetUrl('/suf/logos/min/parque-' + item.Park.Id + '.png')"
                                                class="imgCut hidden-just-tb w-1/5"
                                                v-else
                                            />

                                            <div
                                                class="flex flex-col flex-auto justify-center px-2"
                                            >
                                                <span
                                                    class="font-bold uppercase mb-1"
                                                >
                                                    {{ $t("gallery.fotos") }}
                                                    {{ item.Park.Name }}
                                                </span>
                                                <div class="flex text-xs">
                                                    <div
                                                        class="flex flex-col flex-auto"
                                                    >
                                                        <span
                                                            >{{
                                                                CalculateTotalMedia(item)
                                                            }}
                                                            {{
                                                                $t(
                                                                    "gallery.fotos"
                                                                )
                                                            }}</span
                                                        >
                                                        <span
                                                            class="dateString"
                                                            >{{
                                                                dateString(
                                                                    item.VisitDate
                                                                )
                                                            }}</span
                                                        >
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="active tabs-content" v-if="albumType == AlbumTypeEnum.VIDEO">
                    <div
                        class="flex px-2 items-center justify-center border-b border-black pb-4"
                        v-if="is360Video(videoSelected.LocationId)"
                    >
                        <img
                            :src="$S3AssetUrl('suf/home/photo-pass-logo.png')"
                            alt="logo photo"
                            class="h-auto w-16"
                        />
                        <div
                            class="flex-col font-semibold text-sm leading-4 pl-4"
                        >
                            <div>
                                {{ $t("gallery.vd.360_info") }}
                            </div>
                            <span
                                @click="video360 = true"
                                class="text-xs text-newxcaret-blue underline cursor-pointer"
                                >{{ $t("gallery.vd.more_info") }}</span
                            >
                        </div>
                    </div>

                    <template v-if="!album.Unlocked">
                        <!-- Álbum bloqueado -->
                        <!-- ToDO Por si es necesario agregar texto adicional videos bloqueados -->
                    </template>
                    <template v-else-if="!isVideoBlocked">
                        <!-- compra -->
                        <div class="flex px-2 items-start justify-center pb-4">
                            <img
                                :src="$S3AssetUrl('suf/home/photo-pass-logo.png')"
                                alt="logo photo"
                                class="h-auto w-16"
                            />
                            <div
                                class="flex-col font-semibold text-sm leading-4 pl-4"
                            >
                                <div class="font-bold mb-2">
                                    {{ $t("gallery.vd.pack") }}
                                </div>
                                <ol class="list-decimal ml-3">
                                    <li class="mb-3">
                                        {{ $t("gallery.vd.verify") }}
                                    </li>
                                    <li>
                                        {{ $t("gallery.vd.video_selection_instruction") }}
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </template>

                    <template>
                        <div v-if="!album.Unlocked" class="font-bold p-2">
                            {{ $t("gallery.vd.choose_vd") }}
                        </div>
                        <div v-else class="font-bold p-2">
                            {{ $t("gallery.vd.choose_yours") }}
                        </div>
                        <template v-for="(item, idx) in videos">
                            <div
                                class="cursor-pointer flex flex-col font-semibold text-sm leading-4 px-2 py-2 border-b border-black"
                                @click="videosSelected(item)"
                                :class="item.active && 'bg-yellow-photo'" :key="idx">
                                <div class="flex">
                                    <span class="flex-auto">
                                        {{ $t("gallery.vd.video") }}
                                        {{ item.VideoName }}
                                    </span>
                                </div>
                                <span>
                                    {{ $t("gallery.vd.visit") }}
                                    {{ FormatVisitDate(item.VisitDate || album.VisitDate) }}
                                </span>
                            </div>
                        </template>

                        <div
                            class="hidden flex flex-col font-semibold text-sm leading-4 px-2 my-2"
                        >
                            <div class="flex">
                                <span class="flex-auto"
                                    >Video: Adrenalina Xcaret</span
                                >
                                <span class="flex-1 text-right hidden"
                                    >1min</span
                                >
                            </div>
                            <span>
                                Visita: {{FormatVisitDate(videoSelected.VisitDate ||album.VisitDate)}}
                            </span>
                        </div>

                        <template v-if="hasVideos && isVideoBlocked">
                            <div
                                class="font-semibold text-sm px-2 py-2 mt-3"
                                v-if="isVideoBlocked"
                            >
                                {{ $t("gallery.vd.versions") }}
                            </div>
                            
                            <template v-if="isIOS">
                               <button class="w-full flex justify-center rounded-full py-2 px-4 my-2 bg-yellow-photo font-semibold"  @click="initiateDownload(1)">
                                    {{ $t("gallery.vd.fhd") }}
                                </button>
                                <button class="w-full flex justify-center rounded-full py-2 px-4 my-2 bg-yellow-photo font-semibold"  @click="initiateDownload(0)">
                                    {{ $t("gallery.vd.hd") }}
                                </button>
   
                                <ModalGlobal v-if="showIOSModal" @close-modal="showIOSModal=false">
                                    <template #dialogHeadImg>
                                        <img class="absolute h-22 -top-12 left-0 right-0 m-auto pointer-events-none"
                                            :src="$S3AssetUrl('suf/home/photo-pass-logo.png')" alt="logo photo" />
                                    </template>

                                    <template #dialogHeading>{{ $t('download.title_to_ios_video') }}</template>

                                    <template #dialogDescription>{{ $t('download.message_to_ios_video') }}</template>

                                    <a :disabled="loading" @click.prevent="openVideoAndClose"
                                        class="w-full flex justify-center rounded-full py-3 px-4 mb-4 bg-yellow-photo cursor-pointer font-semibold mx-auto">
                                        {{ $t('download.button_ios_play') }}
                                    </a>

                                    <button @click="showIOSModal = false" :disabled="loading" type="button"
                                        class="w-full flex justify-center rounded-full py-3 px-4 mb-1 border-yellow-photo border bg-white cursor-pointer font-semibold mx-auto">
                                        {{ $t('toolbar.logout_cancel') }}
                                    </button>
                                </ModalGlobal>
                            </template>
                            <template v-else>
                                <span @click="initiateDownload()">
                                    <DownloadLink class="rounded-full py-2 px-4 my-2 bg-yellow-photo font-semibold" :url="videoSelected.Orig">
                                        {{ $t("gallery.vd.fhd") }}
                                    </DownloadLink>
                                </span>
                                <span @click="initiateDownload()">
                                    <DownloadLink class="rounded-full py-2 px-4 my-2 bg-yellow-photo font-semibold" :url="videoSelected.Promo">
                                        {{ $t("gallery.vd.hd") }}
                                    </DownloadLink>
                                </span>
                            </template>
                        </template>
                    </template>
                </div>
            </div>
        </section>
        <TranferProgressWidget />
        <SaveImageButton 
            v-if="currentGalleryItem?.Available == true && isMobileDevice && album?.Unlocked"
            class="downloaderGallery downloaderGalleryLink downloaderGalleryMain bg-yellow-photo text-black border-black py-2 px-6 rounded"
            :imageUrl="freeGallery ? currentGalleryItem?.Mink : currentGalleryItem?.Orig"
            :fileName="`${currentGalleryItem?.MediaId}${currentGalleryItem?.LocationId}.JPG`"
            :albumCode="this.albumes.code"
            :parkId="this.parkId"
            :mediaTotal="this.totalMedia"
        />
    </div>
</template>

<script>
// Vuex
import { mapActions } from 'vuex';

import { LightGallery } from "vue-light-gallery";

// Components
import Banner from "./store/shoppingCartCounterComponent.vue";
import TranferProgressWidget from "../components/photo/DownloadedMultimediaComponent.vue";
import GalleryItem from '@/components/gallery/GalleryItem.vue';
import PaginacionGallery from "@/components/gallery/Pagination.vue";
import DownloadLink from '@components/common/gallery/DownloadLink.vue';
import SaveImageButton from '@components/gallery/SaveImageButton.vue';

import { EventBus } from "@/plugins/global-events";

// Mixins
import HelperMix from "./mixins/helper";
import CartMix from "./mixins/Cart";
import PhotoDroneMix from "./mixins/gallery/PhotoDrone";
import DownloadFilesMix from "./mixins/DownloadFiles";
import methodUser from "./mixins/methodUser";
import Multimedia from "./mixins/Multimedia";
import AlbumesMix from "../components/mixins/Albumes";

//Models
import UnlockMediaRequest, { UnlockTargetEnum } from "@/models/request/UnlockMediaRequest";

// Enums
import AlbumModeEnum from "@/enums/albumMode.js";
import AlbumTypeEnum from "@/enums/albumType.js";
import AlbumSearchTypeEnum from "@/enums/searchType.js";

// Helpers
import { isMobileDevice } from "@helpers/device.helper.js";
import { GetApiErrorMessage } from "@helpers/apiErrorHelper.js";
import { ExtractDateYmd } from "@helpers/dateHelper";

// Services
import { mediaLogService } from '../services/mediaLogService';

export default {
    components: {
        Banner,
        TranferProgressWidget,
        LightGallery,
        GalleryItem,
        PaginacionGallery,
        DownloadLink,
        SaveImageButton
    },
    mixins: [
        HelperMix,
        methodUser,
        Multimedia,
        CartMix,
        DownloadFilesMix,
        PhotoDroneMix,
        AlbumesMix
    ],
    data: () => ({
        AlbumModeEnum,
        AlbumTypeEnum,
        AlbumSearchTypeEnum,
        unselectAllMedia: false,
        albumType: 0,
        albumId: "",
        hasVideo: false,
        hasPhotos: false,
        lightGallery: [],
        diffDay: 0,
        modalSelectVideo: false,
        albumIdx: null,
        album: {},
        albumes: [],
        video360: false,
        galleryIdx: 0,
        videoIdx: 0,
        index: null,
        videoSelected: {},
        code: "",
        parkId: 0,
        visitDate: "",
        parameters: {},
        type: 0,
        gallery: [],
        currentGalleryItem: null,
        //Propiedad para almacenar los multimedios que se seleccionaron para comprar
        lockedMediaList: [],
        videos: [],
        media: [],
        totalMedia: 0,
        perPage: 30, //Propiedad para controlar cuantos elemento traera por pagina
        pagination: [],
        park: {},
        loading: false, //Propiedad para realizar el loading de carga
        downloading: false, //Porpiedad para bloquear los botones de descarga cuando hay una peticion en curso
        items: [],
        freeGallery: false,
        albumNotFound: false,
        albumLoadError: false,
        freeAlbumes: [], //Propiedad que almacenaria todos los parques agregados a la sesion
        initialVideo: "",
        keyVideoLoad: 100,
        initialAlbumes: true, //Propiedad que su estatus habilita que al cargar la pagina por primera vez se muestreen los albumes
        freeAlbum: false, //Propiedad para mostrar los Albumes Free
        posts: [], //Propiedad para obtener todos las fotografias seleccionadas
        page: 1, //Propiedad para obtener en que pagina iniciaria el paginador
        pages: [], //Propiedad para guardar las paginas que contendra el paginador
        selected: [], //Propiedad para guardar las imagenes seleccionadas para descargar
        downloadParameters: {
            ParkId: 0,
            JoinedCode: "",
            NumMedios: 0,
            Paths: [],
            NumberPage: 0,
        },
        isIOS: false,
        showIOSModal: false,
        typeVideo: 1
    }),
    methods: {
        ...mapActions('individualSales', ['resetGalleryItems']),
        /**
         * onSlide get current gallery index
         * @returns {void}
         */
        onSlide({ index }) {
            this.index = index;
        },
        /**
         * Loads the free-albums configuration from the Vuex in-memory cache.
         *
         * @returns {Promise<boolean>} True when the requested free album exists.
         */
        async LoadFreeAlbumsConfiguration() {
            try {
                this.albumLoadError = false;
                this.freeAlbumes = await this.$store.dispatch("GetFreeAlbumsConfiguration");

                this.parkId = Number.parseInt(
                    this.$route.query.ParkId,
                    10
                );

                const freeAlbum = this.freeAlbumes.find(
                    (item) => Number(item.ParkId) === this.parkId
                );

                if (!freeAlbum || !Array.isArray(freeAlbum.Photos)) {
                    this.album = {};
                    this.albumNotFound = true;
                    this.albumLoadError = false;
                    this.gallery = [];
                    this.lightGallery = [];

                    return false;
                }

                this.freeGallery = true;
                this.albumNotFound = false;
                this.albumLoadError = false;
                this.albumType = 0;

                this.album = {
                    Unlocked: true,
                    ExpiresDate: null,
                };

                this.gallery = freeAlbum.Photos;
                this.lightGallery = this.gallery.map(
                    (item) => item.Mink
                );

                this.gallery.forEach((item, index) => {
                    this.$set(item, "MediaId", index);
                    this.$set(item, "Available", true);
                    this.$set(item, "Status", "Success");
                    this.$set(item, "LocationId", "FREE");
                    this.$set(item, "code", "FREEALBUM");
                });

                this.albumes = {};

                return true;
            } catch (error) {
                this.album = {};
                this.albumNotFound = false;
                this.albumLoadError = true;
                this.freeAlbumes = [];
                this.gallery = [];
                this.lightGallery = [];

                Vue.$toast.open({
                    message: GetApiErrorMessage(
                        error,
                        this.$t("messages.service_temporarily_unavailable"),
                        true
                    ),
                    type: "error",
                });

                return false;
            }
        },
        /**
         * Function to load the diferent videos
         * @param {String} locationId - The location ID of the video.
         * @return {void}
         */
        is360Video(locationId) {
            if (locationId === undefined) {
                return;
            }

            return locationId.toString().includes("360");
        },
        /**
         * Function to change the current tab in the gallery.
         * @param {Number} albumType - The type of album to switch to (0 for photos, 1 for videos).
         * @return {void}
         */
        changeTab(albumType) {
            const query = { ...this.$route.query, albumType: albumType };

            this.$router.replace({ query });
            this.albumType = albumType; // 0

            this.getMultimedia();
        },
        /**
         * Function to get the multimedia items based on the current album type.
         * @param {Object} item - The item to check for multimedia.
         * @param {Object} albumes - The albumes object containing multimedia information.
         * @return {void}
         */
        absoluteRoute(item, albumes) {
            const { href } = this.$router.resolve({
                name: "gallery",
                query: {
                    uuid: albumes.uuid,
                    ParkId: item.Park.Id,
                    type: albumes.Type,
                    page: 1,
                    albumType: item.AlbumType,
                    albumId: item.AlbumKey.Id,
                },
            });

            const absoluteURL = new URL(href, window.location.origin).href;

            return absoluteURL;
        },
        /**
         * Unlocks the selected video through the unified media endpoint.
         *
         * @param {Object} params Video unlock parameters.
         * @param {number} params.MediaId Selected video identifier.
         * @param {Object} params.AlbumKey Encrypted album context.
         * @returns {Promise<void>}
         */
        async UnlockVideo({ MediaId, AlbumKey }) {
            try {
                const request = new UnlockMediaRequest({
                    unlockTarget: UnlockTargetEnum.VIDEO,
                    albumKey: AlbumKey,
                    mediaIds: [MediaId],
                });

                this.$store.dispatch("setLoading", true);
                const response = await this.$store.dispatch("unlockMedia", request);
                this.UpdateUnlockedVideo(response);

                Vue.$toast.open({
                    message: this.$t("messages.unlock_video"),
                    type: "success",
                });

                this.modalSelectVideo = false;
            } catch (error) {
                this.modalSelectVideo = false;
                Vue.$toast.open({
                    message: GetApiErrorMessage(
                        error,
                        this.$t("messages.error_unlock_video")
                    ),
                    type: "error",
                });
            } finally {
                this.$store.dispatch("setLoading", false);
            }
        },
        /**
         * Gets the current album from the store using the route parameters.
         *
         * @returns {Promise<boolean>} True when the requested album exists.
         */
        async getCurrentAlbum() {
            this.albumLoadError = false;
            const albums = Object.values(this.$store.state.albumes || {});

            this.albumIdx = albums.findIndex(
                (item) => item?.uuid == this.$route.query.uuid
            );

            if (this.albumIdx < 0) {
                this.album = {};
                this.albumNotFound = true;
                return false;
            }

            const currentAlbums = albums[this.albumIdx];
            const parks = Array.isArray(currentAlbums?.park)
                ? currentAlbums.park
                : [];

            this.page = Number.parseInt(this.$route.query.page, 10);
            this.type = Number.parseInt(this.$route.query.type, 10);
            this.parkId = Number.parseInt(this.$route.query.ParkId, 10);
            this.albumType = Number.parseInt(this.$route.query.albumType, 10);
            this.albumId = this.$route.query.albumId;

            if (
                !parks.length ||
                Number.isNaN(this.parkId) ||
                Number.isNaN(this.albumType) ||
                !this.albumId
            ) {
                this.album = {};
                this.albumNotFound = true;
                return false;
            }

            const currentAlbum = parks.find(
                (element) =>
                    Number(element?.Park?.Id) === this.parkId &&
                    Number(element?.AlbumType) === this.albumType &&
                    element?.AlbumKey?.Id === this.albumId
            );

            if (!currentAlbum) {
                this.album = {};
                this.albumNotFound = true;
                return false;
            }

            this.albumes = currentAlbums;
            this.code = currentAlbums.code;
            this.hasPhotos = parks.some(
                (element) => Number(element.AlbumType) === 0
            );
            this.hasVideo = parks.some(
                (element) => Number(element.AlbumType) === 1
            );
            this.album = currentAlbum;
            this.albumNotFound = false;

            return true;
        },
        /**
         * Function to get the name of the park based on the parkId from the route query.
         * @return {void}
         */
        getNamePark() {
            this.park = Object.values(this.$store.state.Parks)
                .filter(
                    (item) => item.ParkId == parseInt(this.$route.query.ParkId)
                )
                .shift();
        },
        /**
         * Function to select a video from the gallery.
         * @param {Object} video - The video object to select.
         */
        videosSelected(video = {}) {
            this.videoSelected.active = false;

            if (Object.keys(video).length) {
                this.videoSelected = video;
            } else {
                this.videoSelected = this.videos.filter((item) => item.IsAdded);
            }

            if (!this.videoSelected.hasOwnProperty("IsAdded")) {
                this.videoSelected.IsAdded = false;
            }

            this.videoSelected.active = true;            
            this.videoSelected.albumType = this.album.AlbumType;                                    
            return this.videoSelected;
        },
        /**
         * Function to unselect all multimedia items in the gallery.
         * @return {void}
         */
        unSelectAllMultimedia() {
            this.gallery.forEach((item) => {
                if (item.Available) {
                    this.$set(item, 'isAdded', false);
                }
            });
            this.unselectAllMedia = false;
        },
        /**
         * Function to select all multimedia items in the gallery.
         * @return {void}
         */
        selectAllMultimedia() {
            this.gallery.forEach((item) => {
                if (item.Available) {
                    this.$set(item, 'isAdded', true);
                }
            });
            this.unselectAllMedia = true;
        },
        /**
         * Function to selected multimedia item in the gallery.
         * @param {Object} item - The multimedia item to select or unselect.
         * @return {void}
         */
        selectedMediaForDownload(item) {
            const index = this.gallery.findIndex(
                (i) => i.MediaId === item.MediaId
            );
 
            if (index !== -1) {
                this.$set(this.gallery[index], 'isAdded', !this.gallery[index].isAdded);
            }
        },
        /**
         * Function to toggle the selection of an item for purchase.
         * @param {Object} item - The item to toggle selection for purchase.
         * @return {void}
         */
        userUnlockSelection(item) {
            // El 5 remplazarlo con la cantidad de eleccion permitida
            if (this.lockedMediaList.length >= this.mediaMaxSelection && !item?.IsInCart) {
                // ToDo: Definir el mensaje de error
                Vue.$toast.open({
                    message: this.$t("gallery.reached_limit"),
                    type: "error",
                });
                return;
            }

            const index = this.gallery.findIndex(
                (i) => i.MediaId === item.MediaId
            );

            if (index !== -1) {
                this.$set(this.gallery[index], 'IsInCart', !this.gallery[index].IsInCart);
            }

            this.lockedMediaList = this.gallery.filter(
                (item) => item?.IsInCart
            );
        },
        /**
         * Function to unlock user-selected media items.
         * @return {Promise<void>}
         */
        async unlockUserSelectedMedia() {
            try {
                this.$store.dispatch("setLoading", true);
                const request = new UnlockMediaRequest({
                    unlockTarget: UnlockTargetEnum.PHOTO,
                    albumKey: this.album?.AlbumKey,
                    mediaIds: this.lockedMediaList.map(item => item.MediaId)
                });

                const response = await this.$store.dispatch("unlockMedia", request);
                await this.UpdateUnlockedMedia(response);

                this.gallery = this.gallery.sort((a, b) => {
                    return (b.Available === true) - (a.Available === true);
                });

                this.lightGallery = this.gallery.map((item) => item.Mink);
            } catch (error) {
                Vue.$toast.open({
                    message: GetApiErrorMessage(
                        error,
                        this.$t("messages.media_unlock_error")
                    ),
                    type: "error",
                });
            } finally {
                this.$store.dispatch("setLoading", false);
            }
        },
        /**
         * Updates the current video collection with the response returned by
         * the unified Unlock endpoint without forcing a full page reload.
         *
         * @param {Object} media Unified unlock response.
         * @returns {void}
         */
        UpdateUnlockedVideo(media) {
            const unlockedMedia = Array.isArray(media?.UnlockedMedia)
                ? media.UnlockedMedia
                : [];

            let unlockedVideo = null;

            unlockedMedia.forEach((item) => {
                const mediaId = Number(item?.MediaId ?? item?.VideoId);

                if (!Number.isInteger(mediaId) || mediaId <= 0) {
                    return;
                }

                const index = this.videos.findIndex(
                    (video) =>
                        Number(video?.MediaId ?? video?.VideoId) === mediaId
                );

                if (index === -1) {
                    return;
                }

                const target = this.videos[index];

                this.$set(target, "Unlocked", true);
                this.$set(target, "Available", true);

                ["Orig", "Demo", "Prev", "Promo", "Thmb", "Thumb",].forEach((field) => {
                    if (item?.[field] !== undefined && item?.[field] !== null) {
                        this.$set(target, field, item[field]);
                    }
                });

                if (!unlockedVideo) {
                    unlockedVideo = target;
                }
            });

            if (!unlockedVideo) {
                return;
            }

            this.videos.forEach((video) => {
                this.$set(video, "active", false);
            });

            this.$set(unlockedVideo, "active", true);

            this.videoSelected = unlockedVideo;
            this.diffDay = this.diffDays(unlockedVideo.VisitDate);
        },
        /**
         * Function to update the gallery with unlocked media items.
         * @param {Array} media - The array of media items to update.
         * @return {void}
         */
        UpdateUnlockedMedia(media) {
            const redemption = media?.Redemption
                ? {
                    Limit: Number(media.Redemption.Limit || 0),
                    Selected: Number(media.Redemption.Used || 0),
                    Available: Number(media.Redemption.Remaining || 0),
                }
                : null;
            this.$set(this.album, 'DetailsServiceMedia', redemption);
            this.lockedMediaList = [];
            this.unselectAllMedia = false;

            media?.UnlockedMedia?.forEach(item => {
                const index = this.gallery.findIndex(i => i.MediaId === item.MediaId);
                if (index !== -1) {
                    this.$set(this.gallery[index], 'Available', true);
                    this.$set(this.gallery[index], 'Mini', item?.Mini);
                    this.$set(this.gallery[index], 'Mink', item?.Mink);
                    this.$set(this.gallery[index], 'Orig', item?.Orig);
                    this.$set(this.gallery[index], 'Thumb', item?.Thumb);
                    this.lightGallery[index] = item?.Mink;

                    this.$delete(this.gallery[index], 'IsInCart');
                    this.$delete(this.gallery[index], 'isAdded');
                }
            });

            Vue.$toast.open({
                message: this.$t("gallery.media_unlocked_successfully"),
                type: "success",
            });
        },
        /**
         * Funcion para cargar la siguiente pagina de la galeria
         *
         * @param {Number} page
         * ToDo: Validar la funcionalidad de paginación
         * por que jdiazro reporta que las paginas cargadas vuelven a realizar petición.
         **/
        async loadPaginate(page) {
            this.page = page;
            this.unSelectAllMultimedia();
            this.$router.push({ query: { ...this.$route.query, page: page } });
        },
        /**
         * Function to get multimedia items based on the initial album type.
         * @param {Number} initialAlbumType - The type of album to load (0 for photos, 1 for videos).
         * @return {Promise<void>}
         * 
         */
        async getMultimedia(initialAlbumType) {
            try {
                this.$store.dispatch("setLoading", true);

                let extAlbum = Object.values(this.albumes.park).find(
                    (element) => element.AlbumType === 0
                );
                
                //Validación si carga primero albumType video y que tenga fotos y video
                if (initialAlbumType === 1 && this.hasPhotos && this.hasVideo) {
                    //this.album = extAlbum; //Asigna en propiedad album el de fotos
                }
                
                //Verificamos que album no este indefinido para asignarle el album de foto pre-cargado
                if (this.album === undefined) {
                    // Validamos que el album sea de Fotos y que tenga fotos y video
                    if (
                        initialAlbumType === 0 &&
                        this.hasPhotos &&
                        this.hasVideo
                    ) {
                        this.album = extAlbum;
                    }
                }                
                
                //Crea album extra que contenga video                
                let album = Object.values(this.albumes.park)
                    .find((element) => element.AlbumType === 1 && 
                                       element.Park.Id === this.parkId && 
                                       element.AlbumKey.Id == this.albumId);    
                                                                          
                //Asigna y valida y albumtype = 0 carga el albumKey con el que entró | asigna album extra
                let albumKey =
                    this.albumType === 0 ? this.album.AlbumKey : album.AlbumKey;
                // Verificamos si ya fue cargadas la pagina y si es asi ya no realizamos el la peticion
                if (
                    this.media[this.page] != undefined &&
                    this.albumType === 0
                ) {
                    this.$store.dispatch("setLoading", false);
                    this.createNewGallery(this.media[this.page]);
                    return;
                }
                // Verificamos si ya se cargaron los videos para no realizar petición
                else if (this.videos[0] != undefined && this.albumType === 1) {
                    this.parkId = this.videos[0].ParkId;
                    this.$store.dispatch("setLoading", false);
                    return;
                }
                // Parámetros con el albumKey configurado
                let parameters = {
                    page: this.page,
                    type: this.albumType,
                    free: false,
                    albumKey: albumKey,
                };
                //Request a getPhotos que obtiene Media
                const response = await this.$store.dispatch(
                    "getPhotos",
                    parameters
                );
                const responseTags = Array.isArray(response?.AlbumTags)
                    ? response.AlbumTags
                    : [];
                if (responseTags.length && this.album) {
                    this.$set(this.album, "Tags", responseTags);
                }
                //AlbumType = 1 : Video --- 0 : Photo
                if (this.albumType == 1) {
                    if (!response.hasOwnProperty("errorMessage")) {
                        this.videos = response;

                        this.parkId = response[0].ParkId;
                    }
                } else {
                    this.createNewGallery(response);
                    this.parkId = response.ParkId;
                }
                this.parameters = parameters;
                this.$store.dispatch("setLoading", false);
            } catch (error) {
                this.$store.dispatch("setLoading", false);

                Vue.$toast.open({
                    message: GetApiErrorMessage(
                        error,
                        this.$t("messages.gallery_error")
                    ),
                    type: "error",
                });
            }
        },
        /**
         * Function to create a new gallery based on the response from the API.
         * @param {Object} response - The response object containing gallery data.
         * This function updates the media array with the response data, sets the gallery,
         */
        createNewGallery(response) {
            this.media[response.CurrentPage] = response;
            this.gallery = response.Photos.sort((a, b) => (b.Available === true) - (a.Available === true));
            this.totalMedia = response.TotalPhotos;
            this.lightGallery = this.gallery.map((item) => item.Mink);
        },
        /**
         * Function to set the pages for pagination based on the total media count.
         * @return {void}
         */
        setPages() {
            this.pagination = [];
            let numberOfPages = Math.ceil(this.totalMedia / this.perPage);
            for (let index = 1; index <= numberOfPages; index++) {
                this.pagination.push(index);
            }
        },
        /**
         * Function to paginate multimedia items based on the current page and items per page.
         * @param {Array} multimedia - The array of multimedia items to paginate.
         * @return {Array} - The paginated array of multimedia items.
         */
        paginate(multimedia) {
            let page = this.page;
            let perPage = this.perPage;
            let from = page * perPage - perPage;
            let to = page * perPage;
            return multimedia.slice(from, to);
        },
        /**
         * Function to load a video source and set it as the initial video.
         * @param {String} srcVideo - The source URL of the video to load.
         * @param {Number} index - The index of the video in the list.
         * @return {void}
         */
        loadVideo(srcVideo, index) {
            if (index == 0) {
                this.keyVideoLoad = index;
                this.initialVideo = srcVideo;
            }
        },
        /**
         * Function to show panel with free albums and hide others.
         * @return {void}
         */
        freeAlbumEvent() {
            this.freeAlbum = true;
            this.loading = false;
            this.initialAlbumes = false;
        },
        /**
         * Function to navigate back to the initial albumes view and exept free albums.
         * @return {void}
         */
        backTo() {
            this.initialAlbumes = true;
            this.GalleryEmpty = true;
            this.freeAlbum = false;
            this.isVideo = false;
            this.pages = [];
            this.selected = [];
        },
        /**
         * Function to remove query parameters from a URL.
         * @param {String} src - The URL string from which to remove parameters.
         * @return {String} - The URL without query parameters.
         */
        removeParameters(src) {
            return src.split("?")[0];
        },
        /**
         * Function to directly download selected media items.
         * @return {Promise<void>}
         */
        async directDownload() {
            const freeGallery = this.$route.query.freeGallery === true
            let downloadbleImagePosition = 0;
            let mediaDownloadLength = this.mediaSelected.length;
            // Downloading the media from the mediaSelected array.
            const __downloadedMedia = async (downloadbleImagePosition) => {
                if (downloadbleImagePosition < this.mediaSelected.length) {
                    const url = freeGallery
                        ? this.mediaSelected[downloadbleImagePosition].Mink
                        : this.mediaSelected[downloadbleImagePosition].Orig;

                    const fileName = (this.mediaSelected[downloadbleImagePosition]?.Mink 
                                      || this.mediaSelected[downloadbleImagePosition]?.Orig 
                                      || "")
                    .split("/")
                    .pop()
                    ?.split("?")[0] || `foto-${downloadbleImagePosition + 1}.jpg`;

                    if (freeGallery) {
                        await this.directDownloadPublicAsBlob(url, fileName);
                    }else{
                        const createdElement =
                            DownloadFilesMix.methods.directDownloadWithIframe(
                                url,
                                "downloadlePhoto",
                                downloadbleImagePosition
                            );
                    }
                    downloadbleImagePosition++;

                    // Si el valor de page aun sigue siendo menor o igual al todal de medios a iterar volvemos a ejecutar la funcion
                    await __downloadedMedia(downloadbleImagePosition);
                }
            };
            // Downloading the media from the page.
            await __downloadedMedia(downloadbleImagePosition);

            // Verificamos que no sean fotos de albumes de regalo
            if (!this.$route.query.freeGallery)
                await mediaLogService.logGalleryDownload(this.$store, {
                    code: this.albumes.code,
                    parkId: this.parkId,
                    mediaTotal: this.totalMedia,
                    downloadLength: mediaDownloadLength
                });
            
            this.unselectAllMedia = false;
            this.$set(this.mediaSelected, []);
            this.gallery.forEach((item) => this.$set(item, 'isAdded', false));
        },
        /**
         * * The main function of this, is build the zip based on the current album - code -selectedPhotosQuantity
         * @createdDate : 2023-02-09
         */
        async downloadSelectedPhotosAsZip() {
            const freeGallery = this.$route.query.freeGallery === true
            let mediaPagesResponse = null;
            let Paths = [];
            let mediaDownloadLength = this.mediaSelected.length;
            this.mediaSelected.map((image) => {
                // Si son albumes gratuitos estas url no traen firmado y solo tienen la mink para descargar
                if (freeGallery) {
                    Paths.push(image.Mink);
                } else {
                    Paths.push(this.removeParameters(image.Orig));
                }
            });

            if(freeGallery){
                mediaPagesResponse = [{
                    JoinedCode: this.mediaSelected?.[0]?.code + this.parkId,
                    FreeAlbum: freeGallery,
                    Paths: Paths,
                    NumberPage: parseInt(this.$route.query.page),
                    NumMedios: this.mediaSelected.length,
                }];
            }else{
                mediaPagesResponse = await this.$store.dispatch(
                    "getPhotos",
                    {
                        page: parseInt(this.$route.query.page),
                        type: parseInt(this.$route.query.albumType),
                        free: true,
                        albumKey: this.album.AlbumKey,
                    }
                );
                mediaPagesResponse[0].FreeAlbum = freeGallery;
            }

            await this.compressZipPhotos(mediaPagesResponse).then(() => {
                this.unSelectAllMultimedia();
            });
            await mediaLogService.logGalleryDownload(this.$store, {
                code: this.albumes.code,
                parkId: this.parkId,
                mediaTotal: this.totalMedia,
                downloadLength: mediaDownloadLength,
            });
        },
        detectIOS() {
            // Detect iOS
            this.isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
            // Also is Safri or IOS
            const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
            this.isIOS = this.isIOS && isSafari
        },
        async initiateDownload(typeVideo) {
            // 1 = orig, 0 = social network
            if (typeVideo != null)
                this.typeVideo = typeVideo;
            await mediaLogService.logVideoDownload(this.$store, {
                code: this.albumes.code,
                parkId: this.parkId,
                mediaTotal: this.album.TotalMedia,
            });
             if (this.isIOS) {
                // Mostrar instrucciones primero
                this.showIOSModal = true
            }
        },
        openVideoAndClose() {
            this.showIOSModal = false
            // Open to Video
            setTimeout(() => {
                window.open(this.typeVideo = 1 ? this.videoSelected.Orig : this.videoSelected.Promo, '_blank', 'noopener,noreferrer')
            }, 300)
        },
        /**
         * Formats a visit date using the public date-only contract.
         *
         * @param {string|Date|null} value Visit date.
         * @returns {string} Date formatted as YYYY-MM-DD.
         */
        FormatVisitDate(value) {
            return ExtractDateYmd(value);
        },
        /**
         * Formats the tags associated with one media item.
         *
         * @param {Array<string>|string|null} value Media tag value.
         * @returns {string} Comma-separated tags.
         */
        FormatMediaTags(value) {
            const tags = Array.isArray(value)
                ? value
                : value
                    ? [value]
                    : [];

            return [...new Set(
                tags
                    .map((tag) => String(tag || "").trim())
                    .filter(Boolean)
            )].join(", ");
        },
    },
    watch: {
        index() {
            this.currentGalleryItem = this.gallery[this.index] || null;
        },
        "$route.query.page"(page) {
            this.getMultimedia(page);
        },
        gallery() {
            this.galleryIdx++;
            this.setPages();
        },
        videos() {
            this.videosRelated = this.videos;

            if (!Array.isArray(this.videos) || this.videos.length === 0) {
                this.videoSelected = {};
                return;
            }

            const unlockedVideo = this.videos.find(
                (video) =>
                    video?.Unlocked === true ||
                    video?.Unlocked === 1 ||
                    video?.Unlocked === "1"
            );

            const selectedVideo = unlockedVideo || this.videos[0];

            this.videos.forEach((video) => {
                this.$set(video, "active", false);
            });

            this.$set(selectedVideo, "active", true);

            this.videoSelected = selectedVideo;
            this.diffDay = this.diffDays(selectedVideo.VisitDate);
        },
        videoSelected() {
            this.videoIdx++;
        },
        /*Observamos la variable post para ver si tiene algun cambio y asi reasignar
    el valor a setPages y este se actualice con los nuevos valores*/
        posts() {
            this.setPages();
        },
        // Observamos cuando page cambie de valor reseteamos el valor de selected para reiniciar las Fotografias seleccionadas
        page() {
            this.selected = [];
        },
    },
    computed: {
        /**
         * Computed to detect if the device is mobile
         * @return {Boolean} - Returns true if the device is mobile
         */
        isMobileDevice() {
            return isMobileDevice();
        },
        controlValidationDownload() {
            return this.isIOS ? '' : 'nodownload'
        },
        hasVideos() {
            return Object.keys(this.videoSelected).length;
        },
        isVideoBlocked() {
            return this.videoSelected.Unlocked;
        },
        hasUnlockedVideo() {
            return this.videos.some((video) =>
                video?.Unlocked === true ||
                video?.Unlocked === 1 ||
                video?.Unlocked === "1"
            );
        },
        // Computado para verificar si el video seleccionado es FREE
        isFreeVideo() {
            const vs = this.videoSelected;
            const album = this.albumes;
            const types = [1, 2]; //1 Brazaletes | 2 Reservas
            return types.includes(album.Type) && !vs.Unlocked && vs.IsFree;
        },
        // Computado para detectar si el video seleccionado es para seleccion
        isSelectVideos() {
            const vs = this.videoSelected;
            const album = this.album;
            const albums = this.albumes;
            const types = [0]; //1 Codigo de descarga

            return (
                types.includes(albums.Type) &&
                album.Unlocked &&
                !vs.Unlocked &&
                !this.hasUnlockedVideo
            );
        },
        // computarizamos el valor de displayedPosts para obtener simpre el paginador actualizado
        displayedPosts() {
            return this.paginate(this.posts);
        },
        // Computarizamos el valor se selectAll para simpre obtener y settear las fotos seleccionadas en la vista he ir marcando los check
        selectAll: {
            get: function () {
                return this.displayedPosts
                    ? this.selected.length == this.displayedPosts.length
                    : false;
            },
            set: function (value) {
                var selected = [];

                if (value) {
                    this.gallery.forEach(function (image) {
                        selected.push(image);
                    });
                }

                this.selected = selected;
            },
        },
        // Computarizamos siempre la propiedad para que siempre tenga el total de fotos seleccionadas para descarga
        selectAllCounter() {
            return this.selected.length;
        },
        isIndividualMediaSale() {
            return this.gallery.some((item) => !item.Available);
        },
        mediaSelected() {
            return this.gallery.filter((item) => item.isAdded && item.Available);
        },
        /**
         * Fuction to calcule package number based on the available media and selected media.
         */
        mediaMaxSelection() {
            let getPackagesNumber = this.album?.DetailsServiceMedia?.Selected + this.album?.DetailsServiceMedia?.Available;
            return getPackagesNumber - this.album?.DetailsServiceMedia?.Selected || 0;
        },
        /**
         * Function to filter the gallery to only include available items.
         * @return {Array} - An array of available items in the gallery.
         */
        galleryOnlyAvailable() {
            return this.gallery.filter((item) => item.Available);
        }
    },
    created() {
        // Escuchamos el evento para actualizar los items de la galeria
        EventBus.$on('updateGalleryItems', () => {
            this.resetGalleryItems(this.gallery);
        });
    },
    beforeDestroy() {
        // Removemos el evento al destruir el componente
        EventBus.$off('updateGalleryItems', this.resetGalleryItems(this.gallery));
    },
    async mounted() {
        this.detectIOS();

        if (this.$route.query.freeGallery) {
            await this.LoadFreeAlbumsConfiguration();
            return;
        }

        const albumFound = await this.getCurrentAlbum();

        if (!albumFound) {
            return;
        }

        await this.getMultimedia(this.albumType);
        this.getNamePark();
    },
};
</script>

<style scoped>
.skeleton {
    animation: skeleton-loading 1s linear infinite alternate;
}

@keyframes skeleton-loading {
    0% {
        background-color: hsl(200, 20%, 80%);
    }
    100% {
        background-color: hsl(200, 20%, 95%);
    }
}

.skeleton-text {
    width: 25%;
    height: 1.2rem;
    margin: 0.5rem;
    margin-left: 0;
    border-radius: 0.25rem;
}

.skeleton-text__body {
    width: 75%;
}

.skeleton-footer {
    width: 30%;
}

.card__video {
    width: 100%;
    height: 523px;
}

.skeleton.material-icons {
    font-size: 4rem;
    top: 40%;
    opacity: 0.6;
}
</style>